import type { LocationItem } from 'features/contacts/types'

import LocationIcon from 'assets/image/icons/svg/location-icon-yellow.svg'
import {
	type Dispatch,
	type SetStateAction,
	useId,
	useRef,
	useState
} from 'react'
import { type Param, URLSearchParser } from 'shared/search-adapters'
import { ListSelect } from 'shared/ui'

import { api } from '../../api'
import css from './Filters.module.css'

const getLocation = (location: LocationItem) => location.key

Locations.parse = getLocation

Locations.init = (param: URLSearchParams, key: Param): LocationItem[] => {
	const parsed = URLSearchParser.Array(param, key)
	return parsed.map((key, count) => ({ count, key }))
}

export function Locations({
	locations,
	setLocations
}: {
	locations: LocationItem[]
	setLocations: Dispatch<SetStateAction<LocationItem[]>>
}) {
	const id = useId()

	const [fetchLocations, queryOptions] = api.useLazyLocationsQuery()

	const { isPlanned, ...props } = useSomeDegenerateFetching($searchQuery =>
		fetchLocations({
			$searchQuery,
			$take: 10
		})
	)

	let showOptions = queryOptions.data ?? locations
	if (queryOptions.isFetching || isPlanned) {
		showOptions = []
	}

	return (
		<div className={css.set}>
			<label className={css.label} htmlFor={id}>
				Location
			</label>
			<ListSelect
				components={{
					DropdownIndicator: () => (
						<img
							alt='dropdownicon'
							className={'dropdown-simple__icon-location'}
							src={LocationIcon}
						/>
					)
				}}
				getOptionLabel={getLocation}
				getOptionValue={getLocation}
				getTag={loc => loc.key}
				inputId={id}
				isLoading={
					queryOptions.isFetching || queryOptions.isLoading || isPlanned
				}
				isMulti
				onChange={values => setLocations(Array.from(values))}
				{...props}
				options={showOptions}
				placeholder='Search'
				setter={setLocations}
				value={locations}
			/>
		</div>
	)
}

export function useSomeDegenerateFetching(load: (search?: string) => void) {
	const searchRef = useRef('')
	const [timeoutId, setTimeoutId] = useState(0)

	const changeTimeout = (value: number) =>
		setTimeoutId(prev => {
			window.clearTimeout(prev)
			return value
		})

	const fetchWithSearch = () => {
		changeTimeout(0)
		load(searchRef.current ? `${searchRef.current}*` : undefined)
	}

	return {
		isPlanned: timeoutId > 0,
		onInputChange: (value: string) => {
			if (searchRef.current !== value) {
				searchRef.current = value
				const timeOutId = window.setTimeout(fetchWithSearch, 800)
				changeTimeout(timeOutId)
			}
		},
		onMenuClose: () => changeTimeout(0),
		onMenuOpen: fetchWithSearch
	}
}
